import { api, formatApiErrorDetail } from "./api";
import { toast } from "sonner";

/**
 * Thin wrapper around the queue engine endpoints.
 * Every call is a guarded server-side transition — a 409 means someone else
 * already acted on that patient, so we surface it and let the caller refresh.
 */
export async function queueAction(appointmentId, action, body = {}) {
  try {
    const { data } = await api.post(`/queue/${appointmentId}/${action}`, body);
    return { ok: true, data };
  } catch (e) {
    const detail = formatApiErrorDetail(e.response?.data?.detail) || "Action failed";
    toast.error(detail);
    return { ok: false, conflict: e.response?.status === 409, error: detail };
  }
}

export async function callNextPatient(doctorId) {
  try {
    const { data } = await api.post("/queue/call-next", null, {
      params: doctorId ? { doctor_id: doctorId } : {},
    });
    return { ok: true, data };
  } catch (e) {
    const detail = formatApiErrorDetail(e.response?.data?.detail) || "Could not call next patient";
    toast.error(detail);
    return { ok: false, conflict: e.response?.status === 409, error: detail };
  }
}

export async function checkInPatient(payload) {
  try {
    const { data } = await api.post("/queue/check-in", payload);
    return { ok: true, data };
  } catch (e) {
    const detail = formatApiErrorDetail(e.response?.data?.detail) || "Check-in failed";
    toast.error(detail);
    return { ok: false, error: detail };
  }
}

export async function reorderQueue(appointmentIds) {
  try {
    const { data } = await api.post("/queue/reorder", { appointment_ids: appointmentIds });
    return { ok: true, data };
  } catch (e) {
    toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Reorder failed");
    return { ok: false };
  }
}
